import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';

import { DesktopLoanSummary } from './DesktopLoanSummary/DesktopLoanSummary';
import { MobileLoanSummary } from './MobileLoanSummary/MobileLoanSummary';
import { LoanSummaryShell } from '../../../components/LoanSummary/LoanSummaryShell';

export const LoanSummary = ({
    selectedOffer,
    drawdownAmount
}: {
    selectedOffer: TFormalOffer | undefined;
    drawdownAmount: number;
}) => (
    <LoanSummaryShell
        desktop={
            <DesktopLoanSummary
                selectedOffer={selectedOffer}
                drawdownAmount={drawdownAmount}
            />
        }
        mobile={
            <MobileLoanSummary
                selectedOffer={selectedOffer}
                drawdownAmount={drawdownAmount}
            />
        }
    />
);
